import { render, staticRenderFns } from "./AccountantDistributions.vue?vue&type=template&id=0dbcd4f2&"
import script from "./AccountantDistributions.vue?vue&type=script&lang=js&"
export * from "./AccountantDistributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports